export default {
  listing: {
    id: 'bo_sellers-opportunities-listing',
    defaultMessage: 'Listing',
  },
  sku: {
    id: 'bo_sellers-opportunities-SKU',
    defaultMessage: 'SKU',
  },
  listingAndSku: {
    id: 'bo_sellers-opportunities-listing-and-sku',
    defaultMessage: 'Listing / SKU',
  },
  itemCategory: {
    id: 'bo_sellers-opportunities-item_category',
    defaultMessage: 'Item category',
  },
  grade: {
    id: 'bo_sellers-opportunities-grade',
    defaultMessage: 'Grade',
  },
  market: {
    id: 'bo_sellers-opportunities-market',
    defaultMessage: 'Market',
  },
  inventory: {
    id: 'bo_sellers-opportunities-inventory',
    defaultMessage: 'Inventory',
  },
  backbox: {
    id: 'bo_sellers-opportunities-backbox',
    defaultMessage: 'Backbox',
  },
  quantitySold: {
    id: 'bo_sellers-opportunities-quantitySold',
    defaultMessage: 'Qty sold (last 7 days)',
  },
  yourPrice: {
    id: 'bo_sellers-opportunities-your_price',
    defaultMessage: 'Your price',
  },
  backboxPrice: {
    id: 'bo_sellers-opportunities-backbox_price',
    defaultMessage: 'BackBox price',
  },
  recommendedPrice: {
    id: 'bo_sellers-opportunities-recommended_price',
    defaultMessage: 'Recommended price',
  },
  priceDifference: {
    id: 'bo_sellers-opportunities-price_difference',
    defaultMessage: 'Price difference',
  },
  winAllBackbox: {
    id: 'bo_sellers-opportunities-win_all_backbox',
    defaultMessage: 'Win all BackBox',
  },
  winBackbox: {
    id: 'bo_sellers-opportunities-win_backbox',
    defaultMessage: 'Win BackBox',
  },
  updatePrice: {
    id: 'bo_sellers-opportunities-update-price',
    defaultMessage: 'Update price',
  },
  updateAllPrices: {
    id: 'bo_sellers-opportunities-update_all_prices',
    defaultMessage: 'Update all prices',
  },
  seeListing: {
    id: 'bo_sellers-opportunities-see_listing',
    defaultMessage: 'See listing',
  },
  priceDifferencePercentage: {
    id: 'bo_sellers-opportunities-price_difference_percentage',
    defaultMessage: '({percentage}%)',
  },
  listingUpdated: {
    id: 'bo_sellers-opportunities-listing_updated',
    defaultMessage: 'The listing has been updated',
  },
  successOnBulkActions: {
    id: 'bo_sellers-opportunities-success_on_win_all_backbox',
    defaultMessage: `You won {count, plural,
      one {# opportunity!}
      other {# opportunities!}
    }`,
  },
  errorOnBulkActions: {
    id: 'bo_sellers-opportunities-error_on_win_all_backbox',
    defaultMessage:
      'There was an issue with those opportunities when trying to get the backbox: {listings}',
  },
}
